import { render, staticRenderFns } from "./PassForgot.vue?vue&type=template&id=bbebfcfe&scoped=true"
import script from "./PassForgot.vue?vue&type=script&lang=js"
export * from "./PassForgot.vue?vue&type=script&lang=js"
import style0 from "./PassForgot.vue?vue&type=style&index=0&id=bbebfcfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbebfcfe",
  null
  
)

export default component.exports